jQuery(".single li.sharemenu").on('click keypress', function (event) {
  jQuery(".single li.sharemenu").toggleClass("open");
});